export default "__VITE_ASSET__6q$viZ9r__"